import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  AdpWorkforceNowConfig,
  AdpWorkforceNowDataDestinationField
} from '@dadohr/shared/domainTypes/integrations/adp';
import { ONE_MINUTE } from '@dadohr/shared/domainTypes/time';
import { CF, FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  callFirebaseFunction,
  useFirebaseFunction
} from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toAdpWorkforceNowConfigDoc = generateToDocFn<AdpWorkforceNowConfig>();

const COLLECTION = FS.adpWorkforceNowConfig;
const collection = () => store().collection(COLLECTION);
export const adpWorkforceNowConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toAdpWorkforceNowConfigDoc
);

export const useAdpWorkforceNowConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(adpWorkforceNowConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<AdpWorkforceNowConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            clientId: '',
            clientSecret: '',
            sslClientCertificate: '',
            sslClientKey: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeAdpWorkforceNowConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};

export const getAdpWorkforceNowFields = async (orgId: string) => {
  const result = await callFirebaseFunction<
    { label: string; fieldPath: string }[]
  >(CF.adp.getImportFields, { orgId });

  return result;
};

export const getAdpWorkforceNowDataDestinationFields = async (
  orgId: string
) => {
  const result = await callFirebaseFunction<
    AdpWorkforceNowDataDestinationField[]
  >(CF.adp.getDataDestinationFields, { orgId });

  return result;
};

export const useAdpWorkforceNowDataDestinationFields = (orgId: string) => {
  return useFirebaseFunction<AdpWorkforceNowDataDestinationField[]>(
    CF.adp.getDataDestinationFields,
    { orgId },
    [orgId],
    ONE_MINUTE * 15
  );
};
